import React from 'react'
import { flowRight } from 'lodash'
import { withRouter } from 'react-router-dom'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { withTranslationCustom } from 'lib/i18next'

import ControlledModal from 'components/Modal/ControlledModal'
import BosShare from 'components/BillOfSale/BosShare/BosShare'

const BosShareModal = ({ t, match }) => {
    const { bosId } = match.params

    return (
        <ControlledModal
            routedModal
            name="bos-share-modal"
            context="bosShareModal"
            initialTitle={t('billOfSale:share.title')}
            requireUserInput={false}
        >
            {(modalProps) => (
                <BosShare
                    bosId={bosId}
                    onCloseCalled={modalProps.closeModal}
                />
            )}
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    withTranslationCustom('billOfSale'),
    withRouter,
)(BosShareModal)
